/**
 * fieldValueToString
 */

export const fieldValueToString = (value: any): string | null => {
  if (typeof value === 'string') {
    return value;
  }
  if (typeof value === 'number') {
    return (Math.round(value + Number.EPSILON)).toString();
  }
  else if (value === null) {
    return '';
  }
  return null;
}